import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Button } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { parseISO, isFuture, formatISO, addBusinessDays } from "date-fns";
import { updateTask } from "../../api/todo.js";
import { TodoDataTestIds } from "../../constants/dataTestIds.js";
import { RECALL_DELAY_TIME } from "../../constants/recallDelayTime.js";
import { useAxiosProvider } from "../../providers/AxiosProvider.js";
import { useTodoListProvider } from "../../providers/TodoListProvider.js";
import { Status } from "../../todo-list.types.js";
import { useIgnoreForm } from "./Comment.helpers.js";
import { Container, Title, FormContainer, CommentField, Footer } from "./Comment.styles.js";
import "../../helpers/parseArrayQueryParam.js";
import "axios";
import "react-hook-form";
import "@hookform/resolvers/yup";
import "yup";
import "@mui/material/styles";
const Comment = ({ onClose, onSubmit, status }) => {
  const { labels, selectedTodo, onTodo } = useTodoListProvider();
  const axios = useAxiosProvider();
  const {
    register,
    formState: { isDirty, isValid, isSubmitting },
    handleSubmit
  } = useIgnoreForm();
  const disabled = !isDirty || !isValid || isSubmitting;
  const { mutateAsync } = useMutation({
    mutationFn: (data) => {
      return updateTask(axios)((selectedTodo == null ? void 0 : selectedTodo.referenceId) ?? "", data);
    }
  });
  const handleIgnoreTodoTask = (data) => {
    mutateAsync({ ...selectedTodo, ignoreComment: data.comment, status: Status.IGNORED });
    onSubmit();
  };
  const handleRecallTodoTask = (data) => {
    const { dueDate: initialDueDate, ...todoData } = selectedTodo;
    const parsedDueDate = parseISO(initialDueDate);
    const dueDateToUse = isFuture(parsedDueDate) ? parsedDueDate : /* @__PURE__ */ new Date();
    mutateAsync({
      ...todoData,
      dueDate: formatISO(addBusinessDays(dueDateToUse, RECALL_DELAY_TIME), { representation: "date" }),
      dueDateComment: data.comment,
      status: Status.RECALLED
    });
    onSubmit();
  };
  const handleClose = () => {
    onClose();
    onTodo(null);
  };
  const handleClick = (e) => {
    e.stopPropagation();
  };
  const isIgnored = status === Status.IGNORED;
  const label = useMemo(() => isIgnored ? labels.ignoreTodo : labels.recallTodo, [status]);
  const buttonLabel = useMemo(() => isIgnored ? labels.comment.ignore : labels.comment.recall, [status]);
  return /* @__PURE__ */ jsxs(Container, { "data-testid": TodoDataTestIds.TodoIgnoreCommentField, onClick: handleClick, children: [
    /* @__PURE__ */ jsx(Title, { variant: "Lato Emphasized 2", children: label }),
    /* @__PURE__ */ jsxs(FormContainer, { onSubmit: handleSubmit(isIgnored ? handleIgnoreTodoTask : handleRecallTodoTask), children: [
      /* @__PURE__ */ jsx(
        CommentField,
        {
          ...register("comment"),
          placeholder: labels.comment.placeholder,
          multiline: true,
          fullWidth: true,
          rows: 5,
          variant: "filled",
          required: true,
          InputProps: { disableUnderline: true },
          disabled: isSubmitting
        }
      ),
      /* @__PURE__ */ jsxs(Footer, { children: [
        /* @__PURE__ */ jsx(Button, { size: "sm", color: "grey", variant: "borderless", onClick: handleClose, children: labels.comment.cancel }),
        /* @__PURE__ */ jsx(Button, { size: "sm", disabled, type: "submit", children: buttonLabel })
      ] })
    ] })
  ] });
};
export {
  Comment
};
